import * as yup from "yup";

const verifyEmailSchema = yup.object({
  a: yup.number().integer().min(0).max(9).required(),
  b: yup.number().integer().min(0).max(9).required(),
  c: yup.number().integer().min(0).max(9).required(),
  d: yup.number().integer().min(0).max(9).required()
}).required();

export default verifyEmailSchema;
